import React, { FC , useState} from 'react';
import Modal from '@components/Modal';
import { TextArea } from '@/components/DesignLibrary/Atoms';
import Button from '@components/DesignLibrary/Button';
import s from './EditFormSummaryInstructionsModal.module.scss';

type Props = {
    aiSummaryVoice: string | null;
    onClose: () => void;
    onSave: ({
      aiSummaryVoice,
    }:{
      aiSummaryVoice: string | null,
    }) => Promise<void>;
};

const EditFormSummaryInstructionsModal: FC<Props> = (
  {
    aiSummaryVoice,
    onClose,
    onSave,
  }) => {
  const [AiSummaryVoice, setAiSummaryVoice] = useState(aiSummaryVoice);
  return (
    <Modal isAi title="Case Ai" onClose={onClose}>
      <div className={s.modal}>

        <TextArea
          label=""
          description="Specify how you want your AI to summarize the questionnaire. Your AI will then add a summary comment on the client's workflow once it's completed."
          id="aiFormSummaryVoice"
          name="aiFormSummaryVoice"
          onChange={setAiSummaryVoice}
          rows={5}
          value={AiSummaryVoice}
        />
        <Button variant="ai" size="md" fullWidth onClick={() => onSave({aiSummaryVoice:AiSummaryVoice})}>
            Submit
        </Button>

      </div>
    </Modal>
  ); };

export default EditFormSummaryInstructionsModal;